import React from "react";
import { FaCamera } from "react-icons/fa";
import { getImageUrl } from "../../../../Utils/localStorageUtils";

const ProjectBanner = ({ project }) => {
  if (!project) return null; // Avoids errors if project data is missing

  // Extract required details
  const { basicDetails, media, projectDetails } = project;
    // Project Images
    const projectImage = getImageUrl(media?.projectPictures?.[0]) || 
    "https://via.placeholder.com/1440x400?text=No+Image+Available"; // Default fallback image

  // Project Logos
  const projectLogos = media?.projectLogos || [];

  // Other Details
  const reraNumber = projectDetails?.reraNumber;
  const photoCount = media?.projectPictures?.length || 0;

  return (
    <div className="relative w-full h-[400px] overflow-hidden shadow-lg">
      {/* Background Image */}
      <img
        src={projectImage}
        alt="Project Banner"
        className="w-full h-full object-cover"
        onError={(e) => (e.target.src = "https://img.staticmb.com/mbimages/project/Photo_h410_w1440/2024/07/12/Project-Photo-31-Manglam-Aananda-Jaipur-5020643_410_1440_410_1440.jpg")}
      />

        {/* Branding Section (Logos) */}
        <div className="absolute bottom-10 left-[100px] bg-white p-3 rounded-lg shadow-md flex space-x-4 items-center">
        {projectLogos.length > 0 ? (
          projectLogos.map((logo, index) => (
            <img
              key={index}
              src={getImageUrl(logo)}
              alt={`Project Logo ${index + 1}`}
              className="h-12"
              onError={(e) => (e.target.style.display = "none")} // Hide if image fails to load
            />
          ))
        ) : (
          <span className="text-gray-500 text-sm">No Logo Available</span>
        )}
      </div>
      {/* RERA Approved Badge (Only if RERA number exists) */}
      {reraNumber && (
        <div className="absolute bottom-0 left-[100px] bg-green-600 text-white px-3 py-1 text-xs font-semibold rounded-md">
          RERA APPROVED: {reraNumber}
        </div>
      )}

      {/* Photos Count Badge */}
      {photoCount > 0 && (
        <div className="absolute bottom-6 right-[100px] bg-white px-4 py-2 rounded shadow-md flex items-center space-x-2">
          <FaCamera className="text-gray-700" />
          <span className="text-gray-700 font-semibold">{photoCount} Photos</span>
        </div>
      )}
    </div>
  );
};

export default ProjectBanner;
